import request from '@/utils/request';

export interface IGetDraftList {
  projectName?: string;
  projectId?: number;
  startTime?: string;
  endTime?: string;
  pageNum?: number;
  pageSize?: number;
}

/**
 * 获取草稿列表
 * @param data
 * @returns
 */
export const getDraftList = async <T>(data: IGetDraftList): Promise<T> => {
  const res = await request('/api/rest/dlt/project/page', {
    method: 'POST',
    data,
  });
  return res;
};

export interface IDeleteDraft {
  projectId: number;
  version?: number;
}
/**
 * 删除草稿
 * @param data
 * @returns
 */
export const deleteDraft = async (data: IDeleteDraft) => {
  const res = await request('/api/rest/dlt/project/delete', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 查询用户权益
 * @param data
 * @returns
 */
export const queryRight = async (data?: any) => {
  const res = await request('/api/rest/dlt/user/right/get', {
    method: 'POST',
    data,
  });
  return res;
};
/**
 * 已经用了的席位
 * @param data type：1数字人 2音色
 * @returns
 */
export const fetchUsedSeats = async (data: {}) => {
  const res = await request('/api/rest/dlt/template/personal/used', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 兑换码使用记录查询
 * @param data
 * @returns
 */
export const queryExchangeCode = async (data?: any) => {
  const res = await request('/api/rest/dlt/user/right/consume/queryExchangeCode', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 使用兑换码
 * @param data
 * @returns
 */
export const postCode = async (data?: { exchangeCode: string }) => {
  const res = await request('/api/rest/dlt/user/right/consume/exchangeCode', {
    method: 'POST',
    data,
  });
  return res;
};
